import React, {Component} from 'react'
import { bindActionCreators } from 'redux'
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux'
import { EventIcon } from '../../Svg/Index.js'
import Truncate from 'react-truncate';

class MeetingCard extends Component {
    handleGoToThread = (_id)=> {
        this.props.history.push({
            pathname: `/community/meetings/${_id}`,
        })
    }

    render() {
        const { id, title, intro, image, date, end_time, address } = this.props;

        return (
            <div className="c-card">
                <div className="c-card__inner">
                    <div className="c-card__author c-card__author--alt">
                        <EventIcon />
                    </div>
                    <div className="c-card__content" onClick={() => this.handleGoToThread(id)}>
                        {
                            image && (
                                <div className="c-card__media">
                                    <img src={image.meeting_medium} style={{width: '100%'}} alt=""/>
                                </div>
                            )
                        }
                        <div className="c-card__label c-card__label--alt u-small">
                            <span>{date} { end_time ? `– ${end_time}` : '' } <br />{address}</span>
                        </div>

                        <span className="c-card__title">{title}</span>
                        
                        <div className="c-card__message">
                            <Truncate lines={3}>
                                {intro}
                            </Truncate>
                        </div>

                    </div>
                </div>
            </div>
        )
    }
}

const mapStateToProps = state => {
    return {
    }
}

const mapDispatchToProps = dispatch => {
    return {
        actions: bindActionCreators({}, dispatch)
    }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(MeetingCard))